{
  "validation-errors": {
    "min-length": "Мінімальна довжина має бути не менше 2",
    "max-length": "Максимальна довжина має бути не більше 50"
  },

  "group-header": {
    "title": {
      "organization": "Перелік учасників",
      "group": "Група: {{name}}"
    }
  },

  "invite-user": {
    "validation-errors": {
      "incorrect-email-in-csv": "Некоректна електронна адреса в вашому CSV файлі",
      "email-max-length": "Електронна адреса не може бути довшою за 50 символів",
      "at-least-one-email": "Потрібно вказати хоча б одну електронну адресу",
      "incorrect-email": "Некоректний email",
      "email-min-length": "Мінімальна довжина маж бути не менше 2",
      "email-max-length-form": "Максимальна довжина маж бути не білше 50",
      "csv-invalid-type": "Дозволені лише файли CSV.",
      "csv-max-size": "Файл CSV повинен бути не більше 1MB"
    },

    "or": "Або",

    "trigger": "Додати учасника",
    "placeholder": "Введіть е-mail",
    "label": "Додати учасника",
    "title": {
      "success": "Підтвердження додавання учасників",
      "default": "Додати учасника",
      "several": "Додати декілька учасників"
    },

    "csv-instruction": {
      "first-line": "Перетягніть .csv файл сюди або",
      "second-line": "завантажте з вашого пристрою"
    },

    "close": "Закрити",
    "button": {
      "agree": "Ок",
      "submit": "+ Запросити",
      "loading": "Запрошуємо..."
    },

    "invite-all-reminder": "Запросити всіх учасників знову"
  },
  "move-to-another-group": {
    "trigger": "Перемістити в іншу групу",
    "title": "Перенесення користувачів",
    "close": "Відмінити",
    "message": "Виберіть групу, куди буде перенесений/ні користувач/чі",
    "placeholder": "Група",
    "submit": {
      "loading": "Переносимо...",
      "text": "Перенести"
    }
  }
}
